// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import "babel-polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
Vue.config.errorHandler = (error, vm, info) => {
  window.Owl &&
    window.Owl.addError(
      {
        name: 'VUE_RUNTIME_ERROR',
        msg: JSON.stringify({
          content: error.message,
          component: vm.$options.name,
          info: info
        })
      },
      {
        level: window.Owl.errorModel.LEVEL.ERROR,
        combo: true
      }
    )
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
